var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-to-top-box"},[_c('img',{attrs:{"src":require("@/assets/images/rateTable.png")},on:{"click":function($event){return _vm.onShowRateTable()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }